import {
  realmPlugin,
  Cell,
  createRootEditorSubscription$,
} from "@mdxeditor/editor";
import { KEY_DOWN_COMMAND, COMMAND_PRIORITY_EDITOR } from "lexical";
// This function will be our plugin
export const preventUnderlinePlugin = realmPlugin({
  init(realm) {
    const handleKeyDown = (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key === "u") {
        event.preventDefault();
        // Returning true tells Lexical to stop processing this command
        return true;
      }
      // Continue processing other commands if not the underline shortcut
      return false;
    };

    // Register the keyboard command to intercept 'Ctrl+U' or 'Cmd+U'
    realm.pub(createRootEditorSubscription$, (theRootEditor) => {
      return theRootEditor.registerCommand(
        KEY_DOWN_COMMAND,
        handleKeyDown,
        COMMAND_PRIORITY_EDITOR
      );
    });
  },
});
